
import { IonApp, IonRouterOutlet } from '@ionic/vue';
import { defineComponent } from 'vue';
import StarryBackground from './components/StarryBackground.vue';
import { useTheme } from './composables/useTheme';

export default defineComponent({
  name: 'App',
  components: {
    IonApp,
    IonRouterOutlet,
    StarryBackground
  },
  setup() {
    const { isDark } = useTheme();
    return { isDark };
  }
});
